import { Component, h, Host, Prop, State, Watch } from "@stencil/core";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

@Component({
    tag: "ux-date-time",
    shadow: true
})
export class DateTime {
    /** UTC time in a ISO_8601 Format https://en.wikipedia.org/wiki/ISO_8601 example: 2020-05-20 17:32:33 */
    @Prop({ reflect: true }) readonly utc: string = "";
    /** Format String according to https://day.js.org/docs/en/display/format example: "DD.MM.YYYY HH:mm".
     *  You can escape characters by wrapping them in [].
     *  For now this webcomponent displays localized parts in a date like "Monday" only in English
     */
    @Prop({ reflect: true }) readonly format: string = "";

    /** Holds the final result */
    @State() formattedDateTime = "";

    @Watch("utc")
    @Watch("format")
    componentWillLoad() {
        const { utc, format } = this;
        if (utc === "" || format === "") {
            this.formattedDateTime = "";
            return;
        }
        const utcDate = dayjs.utc(utc);
        if (!utcDate.isValid()) {
            /* eslint-disable-next-line no-console */
            console.error(`ux-date-time received an invalid date. UTC: "${utc}"`);
            this.formattedDateTime = "";
            return;
        }
        this.formattedDateTime = utcDate.local().format(format);
    }

    public render() {
        return <Host class="ux-date-time">{this.formattedDateTime}</Host>;
    }
}
